import React, { Component } from 'react'
import { connect } from 'react-redux'
import { API_URL } from '../../../constants'

import ReactHoverObserver from 'react-hover-observer'

// Actions
import { getOccurenceFiles } from '../../../actions/mypage'

// Components
import Gallery from '../../../shared/components/Gallery'

// Utils
import { translation } from '../../../utils/helpers'

// Styles
import './index.scss'

// Elements
import LabelWrapper from '../../elements/labelWrapper'

class OthertaskHover extends Component {

  constructor (props) {
    super(props)
    this.onHoverChanged = this.onHoverChanged.bind(this)
    this.state = {
      active: false,
      status: 'loading'
    }
  }

  getFiles (id) {
    this.props.getOccurenceFiles(id).then((res) => {
      this.setState({
        files: res.data,
        status: 'loaded'
      })
    }, () => {
      this.setState({
        status: 'failed'
      })
    })
  }

  onHoverChanged (data) {
    if (data.isHovering !== this.state.active) {
      this.setState({
        active: data.isHovering,
        status: (data.isHovering) ? this.state.status : 'loading',
        files: (data.isHovering) ? this.state.files : undefined
      }, () => {
        if (data.isHovering) {
          this.getFiles(this.props.id)
        }
      })
    }
  }

  renderAttachments (files) {
    if (files.length === 0) return null

    let imgFiles = []
    let otherFiles = []
    files.forEach(file =>
      file.IsImage
      ? imgFiles.push(file)
      : otherFiles.push(file)
    )

    const renderFile = (file, index) => {
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      return (
        <li key={index} className='file-document'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={file.FileURL}>
            {file.FileName}
          </a>
        </li>
      )
    }
    // Render image
    const renderImage = (image, key) => {
      return (
        <div key={key}>
          <a href={image.FileURL} data-lightbox='gallery' data-title={image.FileName}><img src={image.ThumbURL} /></a>
        </div>
      )
    }

    return (
      <div className='attachments'>
        <LabelWrapper labelText={translation('352')}>
          {otherFiles.length !== 0 && (
            <div className='docs'>
              <ul>
                {otherFiles.map(renderFile)}
              </ul>
            </div>
          )}
          {imgFiles.length !== 0 && <Gallery files={imgFiles} renderImage={renderImage} />}
        </LabelWrapper>
      </div>
    )
  }

  renderPopup () {
    if (this.state.status === 'loading') {
      return (
        <div className='hover_extent-popup'>
          <p className='loading'>
            <span className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              <span className='sr-only'>{translation('13382')}...</span>
            </span>
          </p>
        </div>
      )
    }
    if (this.state.status === 'failed') {
      return (
        <div className='hover_extent-popup'>
          <p className='loading'>
            {translation('2269')}
          </p>
        </div>
      )
    }
    return (
      <div className='hover_extent-popup'>
        <div className='extent_box clearfix'>
          <div>
            <LabelWrapper labelText={translation('1021')}>
              {this.props.item.Description ? this.props.item.Description : translation('15101')}
            </LabelWrapper>
            {this.state.files && this.renderAttachments(this.state.files.OtherTaskFiles)}
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <ReactHoverObserver
        className='othertaskHover'
        hoverDelayInMs={1000}
        hoverOffDelayInMs={500}
        onHoverChanged={this.onHoverChanged}
        shouldDecorateChildren={false}>
        <span>
          {this.props.children}
          {this.state.active && this.renderPopup()}
        </span>
      </ReactHoverObserver>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  getOccurenceFiles
})(OthertaskHover)



// WEBPACK FOOTER //
// ./src/app/shared/components/OthertaskHover/index.js